import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import Reveal from "../../../src/components/Reveal";

export default function FeaturedService() {
  return (
    <section
      data-testid="home-featured-service"
      className="section-pad relative overflow-hidden"
      style={{ background: "#F8F9FA" }}
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-6 order-2 lg:order-1">
          <div className="flex items-center gap-3 mb-5">
            <span className="gold-rule" />
            <span className="overline">Servicio destacado</span>
          </div>
          <h2 className="font-serif text-navy-900 text-3xl md:text-4xl lg:text-5xl leading-tight">
            Asesoría en <em className="italic" style={{ color: "#C5A059" }}>Derecho Tributario</em>
          </h2>
          <p className="mt-6 text-slate-600 leading-relaxed text-[17px]">
            Acompañamos a personas naturales y jurídicas en planeación, cumplimiento y defensa fiscal en los niveles nacional, departamental y municipal — protegiendo intereses patrimoniales y fortaleciendo la eficiencia tributaria.
          </p>

          <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              "Planeación tributaria",
              "Defensa fiscal ante DIAN",
              "Cumplimiento normativo",
              "Gestión de obligaciones",
            ].map((b) => (
              <li key={b} className="flex items-center gap-3 text-[15px] text-slate-700">
                <Check size={16} style={{ color: "#C5A059" }} strokeWidth={2.4} />
                {b}
              </li>
            ))}
          </ul>

          <Link
            to="/servicios/derecho-tributario"
            data-testid="featured-cta-detalle"
            className="mt-10 inline-flex items-center gap-2 px-7 py-3.5 bg-navy-900 text-white text-sm font-medium rounded-sm hover:bg-navy-800 transition-colors"
          >
            Ver detalle del servicio
            <ArrowRight size={15} />
          </Link>
        </Reveal>

        <Reveal className="lg:col-span-6 order-1 lg:order-2" delay={120}>
          <div className="relative">
            <img
              src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85"
              alt="Documento legal y planeación tributaria"
              loading="lazy"
              className="w-full aspect-[5/4] object-cover"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}